/**
 * Tam ekran düğmesi (#map-controls içine) + ilk yatay çevirmede tek seferlik
 * ipucu. Fullscreen API desteklenmeyen yerde (iPhone Safari) düğme ve ipucu
 * gösterilmez; immersive landscape CSS yatayda zaten devrede.
 */
export function initFullscreen(controls: HTMLElement) {
  const el = document.documentElement;
  const supported =
    typeof el.requestFullscreen === "function" &&
    typeof document.exitFullscreen === "function";

  if (supported) {
    const btn = document.createElement("button");
    btn.type = "button";
    btn.title = "Tam ekran";
    btn.textContent = "⤢";
    btn.addEventListener("click", () => {
      if (document.fullscreenElement) document.exitFullscreen();
      else el.requestFullscreen().catch(() => { /* yoksay */ });
    });
    document.addEventListener("fullscreenchange", () => {
      btn.textContent = document.fullscreenElement ? "⤡" : "⤢";
    });
    controls.appendChild(btn);
  }

  initLandscapeHint(supported);
}

function initLandscapeHint(supported: boolean) {
  if (!supported) return; // butonu olmayan cihazda "Tap ⤢" yanıltıcı olur
  const mq = window.matchMedia("(orientation: landscape) and (max-height: 500px)");
  const show = () => {
    if (!mq.matches || sessionStorage.getItem("lm_ls_hint")) return;
    sessionStorage.setItem("lm_ls_hint", "1");
    const t = document.createElement("div");
    t.className = "ls-hint";
    t.textContent = "Tap ⤢ for fullscreen";
    document.body.appendChild(t);
    setTimeout(() => t.remove(), 3000);
  };
  mq.addEventListener?.("change", show);
  show();
}
